import {images} from '../../constants';

export const sliderData = [
    {
        title: "Let us start this tale here.",
        image: images.scene01,
        placeholder: images.scene01LQIP,
        description: '"After a challenging journey as a chef, a restless desire for new intellectual horizons began to brew inside me."',
    },
    {
        title: "The Doom and Gloom",
        image: images.scene02,
        placeholder: images.scene02LQIP,
        description: '"The COVID-19 pandemic had a devastating impact on the service industry, but I chose to view it as an opportunity to reinvent myself and emerge from the ashes like a phoenix."',
    },
    {
        title: "Rising above Adversity",
        image: images.scene03,
        placeholder: images.scene03LQIP,
        description: '"I embarked on a rigorous training regimen to prepare myself for the challenge ahead."',
    },
    {
        title: "The moment is now, let's seize it!",
        image: images.scene04,
        placeholder: images.scene04LQIP,
        description: '"Now that I have laid a strong foundation through the start of my education, I am eager to dive headfirst into the adventure in front of me!"',
    },
];